import TextTranslated from "./Text";
export default TextTranslated